/**
 * The action bar shown above the shipments table. Includes a search field and
 * filters to help find shipments. Also includes a create shipment button and
 * actions for bulk-editing shipments.
 */

import React from "react";
import { useRef } from "react";
import PropTypes from "prop-types";
import { TableActionBar } from "@amzn/meridian/table";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import calendarTokens from "@amzn/meridian-tokens/base/icon/calendar";
import Tooltip from "@amzn/meridian/tooltip";
import filterIconTokens from "@amzn/meridian-tokens/base/icon/filter";
import IncomingShipmentsSearchField from "./incoming-shipments-search-field";
import IncomingShipmentsSearchFieldNew from "./incoming-shipments-search-field-new";
import HorizontalStickyContainer from "../app/horizontal-sticky-container";
import useIncomingShipmentsFiltersNew from "../../hooks/use-incoming-shipments-filters-new";
import usePageLayoutContentRectangle from "../../hooks/use-page-layout-content-rectangle";
import IncomingShipmentsDateFilterNew from "./incoming-shipments-date-filter-new";
import Column from "@amzn/meridian/column";
import AnalyticsModal from "./analytics-modal";
import incomingShipmentPropType from "../../prop-types/incoming-shipment";

const HorizontalStickyRow = props => (
  <HorizontalStickyContainer Component={Row} {...props} />
)

const FilterButton = () => {
  const { sheet: [newSheetOpen, newSetSheetOpen] } = useIncomingShipmentsFiltersNew();

  const buttonRef = useRef();

  return (
    <Tooltip title="Filters" position="top">
      <Button
        ref={buttonRef}
        onClick={() => newSetSheetOpen(!newSheetOpen)}
        type="icon"
      >
        <Icon tokens={filterIconTokens}>Filters</Icon>
      </Button>
    </Tooltip>
  );
};

FilterButton.propTypes = {
  isNewView: PropTypes.bool
};

const AnalyticsButton = ({
  warehouseId
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <Button
        type="icon"
        onClick={openModal}
        size="large"
        circular={false}
        disabled={false}
      >
        <Icon tokens={calendarTokens} color="primary"></Icon>
      </Button>
      <AnalyticsModal
        open={isModalOpen}
        onClose={closeModal}
        warehouseId={warehouseId}
       
      />
    </>
  );
};

const IncomingShipmentsActionFilterBar = (props) => {
    const {
        warehouseId,
        isNewView,
      } = props;
  const Wrapper = props.stick ? HorizontalStickyRow : Row
  const { width: contentWidth = 1200 } = usePageLayoutContentRectangle()
  const mobile = contentWidth < 600
  return (
    <Wrapper widths="fill">
      <TableActionBar alignmentHorizontal="justify">
        <Row spacing="200">
          <Row>
            <Column>
              <IncomingShipmentsDateFilterNew />
            </Column>
            <Column>
              {isNewView ? (
                <IncomingShipmentsSearchFieldNew mobile={mobile} />
              ) : (
                <IncomingShipmentsSearchField mobile={mobile} />
              )}
            </Column>
            <Column>
              <FilterButton isNewView={isNewView} />
            </Column>
          </Row>
        </Row>
        <Row spacing="200">
          <AnalyticsButton
            warehouseId={warehouseId}
          />
        </Row>
      </TableActionBar>
    </Wrapper>
  );
}

IncomingShipmentsActionFilterBar.propTypes = {
  stick: PropTypes.bool.isRequired,
  incomingShipments: PropTypes.arrayOf(incomingShipmentPropType),
  warehouseId: PropTypes.string.isRequired,
  isNewView: PropTypes.bool
}

export default IncomingShipmentsActionFilterBar